<dashboardnav>
    <cradua-cof-ostatus
    [cofostatuss]="cofostatuss$ | async"
    (cofostatus)="onSubmitCofOStatus($event)"
    (deleteCofOStatusEvent)="onDeleteCofOStatus($event)"
    *ngIf="(isLoadingCofOStatus$ | async ) === false"
    >
  </cradua-cof-ostatus>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingCofOStatus$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
